"use client";

import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { debounce } from "@/ui/hooks/use-debounced-value";
import { Label } from "@/ui/shadcn/label";
import { StatefulColorPicker } from "@/ui/stateful-color-picker";
import type { YnsComponentForm } from "../types";
import type { CategoryMenu } from "./category-menu";
import type { CategoryMenuStoreBuilderConfigFactory } from "./config";

export const CategoryMenuForm: YnsComponentForm<typeof CategoryMenuStoreBuilderConfigFactory> = ({
	theme,
}) => {
	const context = useStoreBuilderContext<typeof CategoryMenu>();

	return (
		<div className="grid gap-4 relative pb-20">
			<Label className="grid gap-2 w-max">
				<span>Background Color</span>
				<StatefulColorPicker
					defaultValue={theme.backgroundColor}
					onValueChange={debounce(
						(value) => {
							context.saveSelectedPageSectionThemeField({
								fieldPath: "backgroundColor",
								value,
							});
						},
						300,
						{ trailing: true },
					)}
				/>
			</Label>

			<Label className="grid gap-2 w-max">
				<span>Font Color</span>
				<StatefulColorPicker
					defaultValue={theme.color}
					onValueChange={debounce(
						(value) => {
							context.saveSelectedPageSectionThemeField({
								fieldPath: "color",
								value,
							});
						},
						300,
						{ trailing: true },
					)}
				/>
			</Label>

			<Label className="grid gap-2 w-max">
				<span>Hover Background Color</span>
				<StatefulColorPicker
					defaultValue={theme.hoverBackgroundColor}
					onValueChange={debounce(
						(value) => {
							context.saveSelectedPageSectionThemeField({
								fieldPath: "hoverBackgroundColor",
								value,
							});
						},
						300,
						{ trailing: true },
					)}
				/>
			</Label>
		</div>
	);
};
